/* Cart3 footer columns (sections/c3-footer.liquid).
   The columns are rendered open, so everything is visible without JavaScript.
   Below 750px they become collapsed accordions; from 750px they stay open and the
   heading is not a toggle. No animation is used, so reduced-motion needs no extra work. */
if (!customElements.get('c3-footer-columns')) {
  customElements.define(
    'c3-footer-columns',
    class C3FooterColumns extends HTMLElement {
      constructor() {
        super();
        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.onMediaChange = this.update.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        this.desktopQuery.addEventListener('change', this.onMediaChange);
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
      }

      disconnectedCallback() {
        this.desktopQuery.removeEventListener('change', this.onMediaChange);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      update() {
        const isDesktop = this.desktopQuery.matches;
        this.querySelectorAll('details').forEach((details) => {
          details.open = isDesktop;
          const summary = details.querySelector('summary');
          if (!summary) return;
          if (isDesktop) {
            summary.setAttribute('tabindex', '-1');
          } else {
            summary.removeAttribute('tabindex');
          }
        });
      }

      handleClick(event) {
        if (this.desktopQuery.matches && event.target.closest('summary')) event.preventDefault();
      }

      /* Theme editor: open the column that is selected in the sidebar */
      handleBlockSelect(event) {
        const details = event.target.closest('details');
        if (details) details.open = true;
      }
    }
  );
}
